export const normalizePathForAuth = (pathname: string, basePath: string) =>
  pathname === basePath || pathname.startsWith(basePath + "/") ? basePath : pathname;

export const matchesPublicRoute = (pathname: string, publicRoutes: string[]) =>
  publicRoutes.some((route) => pathname === route || pathname.startsWith(route + "/"));

export const isSpecialRoute = (pathname: string, specialRoutes: string[]) =>
  specialRoutes.some((route) => pathname.startsWith(route));
